import { AvailableRoom, StaticRoom } from '@features/rooms/types';
import { byPriorityThenPrice } from '@features/rooms/helpers/byPriorityThenPrice.helper';
import { RoomSchema } from './schemas';
import { Room } from './types';

type MapToRooms = (staticRooms: StaticRoom[], availableRooms: AvailableRoom[]) => Room[];

export const toRoomItems: MapToRooms = (staticRooms, availableRooms) => {
  const mappedRooms = staticRooms.reduce<Array<Room>>(
    (rooms, { room_id, title, image_url, priority }) => {
      const availableRoom = availableRooms.find(({ id }) => id === room_id);

      const result = RoomSchema.safeParse({
        id: room_id,
        name: title,
        image: {
          url: image_url ?? '',
        },
        price: availableRoom
          ? {
              amount: availableRoom?.price_per_stay?.amount,
              currencyCode: availableRoom?.price_per_stay?.currency_code,
            }
          : null,
        priority: priority ?? null,
      });

      if (result.success) {
        return [...rooms, result.data];
      }

      return [...rooms];
    },
    []
  );

  return mappedRooms.sort(byPriorityThenPrice);
};
